import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    Button,
    Icons,
    CountryPicker,
    TextField,
    StatePicker,
    ZIPCodeField,
    FlexRow,
    FlexCol
} from 'sarsaparilla';
import { addChange, clearChange, getRef } from '../../actions/changes';
import { AddressProps } from '../../props/address';
import pageStyles from './StewardAssetEditPage.scss';
import {
    ADDRESS1_PATH,
    ADDRESS2_PATH,
    ADDRESS3_PATH,
    CITY_PATH,
    STATE_PATH,
    POSTAL_CODE_PATH,
    COUNTRY_PATH
} from '../../constants/paths';

const propTypes = {
    index: PropTypes.number,
    value: AddressProps,
    addressType: PropTypes.string,
    onRemove: PropTypes.func,
    getRef: PropTypes.func.isRequired,
    addChange: PropTypes.func.isRequired,
    clearChange: PropTypes.func.isRequired
};

export class AddressEdit extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            record: this.props.value,
            ref: this.props.getRef(
                this.props.addressType,
                { id: this.props.value.id },
                0,
                [STATE_PATH, COUNTRY_PATH].reduce((m, f) => Object.assign(m, { [f]: props.value[f] }), {})
            )
        };

        this.handleChange = this.handleChange.bind(this);
        this.doRemove = this.doRemove.bind(this);
        if (!props.value[STATE_PATH]) {
            this.props.addChange(this.state.ref, { [STATE_PATH]: '' });
        }
        if (!props.value[COUNTRY_PATH]) {
            this.props.addChange(this.state.ref, { [COUNTRY_PATH]: '' });
        }
    }

    handleChange(event, path) {
        const { value } = event.target;

        const change = { [path]: value };

        this.setState((prevState) => ({
            ...prevState,
            record: { ...prevState.record, ...change }
        }), () => this.props.addChange(this.state.ref, change));
    }

    doRemove() {
        if (this.props.value.id) {
            this.props.addChange(this.state.ref, { _delete: true });
        }
        else {
            this.props.clearChange(this.state.ref);
        }
        this.props.onRemove(this.props.value._key);
    }

    render() {
        const { index } = this.props;
        const { record } = this.state;

        return (
            <div className={pageStyles['section-box']}>
                <Button
                    appearance="subtle-danger"
                    onClick={this.doRemove}
                    className={pageStyles['delete-button']}
                    iconBeforeElement={<Icons.IconClose />} />
                <FlexRow>
                    <FlexCol xs={12} className="mb-1">
                        <CountryPicker
                            label="Country"
                            id={`country_address-${index}`}
                            value={get(record, COUNTRY_PATH)}
                            onChange={(e) => this.handleChange(e, COUNTRY_PATH)}
                            isRequired />
                    </FlexCol>
                    <FlexCol xs={12} className="mb-1">
                        <TextField
                            label="Street Address"
                            id={`street_address-${index}`}
                            value={get(record, ADDRESS1_PATH)}
                            onChange={(e) => this.handleChange(e, ADDRESS1_PATH)}
                            isRequired />
                    </FlexCol>
                    <FlexCol xs={12} className="mb-1">
                        <TextField
                            label="Street Address (cont.)"
                            id={`street_address_cont-${index}`}
                            value={get(record, ADDRESS2_PATH)}
                            onChange={(e) => this.handleChange(e, ADDRESS2_PATH)} />
                    </FlexCol>
                    <FlexCol xs={12} className="mb-1">
                        <TextField
                            label="Street Address (cont.)"
                            id={`street_address_cont-${index}`}
                            value={get(record, ADDRESS3_PATH)}
                            onChange={(e) => this.handleChange(e, ADDRESS3_PATH)} />
                    </FlexCol>
                    <FlexCol md={4} className="mb-1">
                        <TextField
                            label="City"
                            id={`city-${index}`}
                            value={get(record, CITY_PATH)}
                            onChange={(e) => this.handleChange(e, CITY_PATH)} />
                    </FlexCol>
                    <FlexCol md={4} className="mb-1">
                        <StatePicker
                            label="State"
                            id={`state-${index}`}
                            value={get(record, STATE_PATH)}
                            onChange={(e) => this.handleChange(e, STATE_PATH)}
                            isRequired />
                    </FlexCol>
                    <FlexCol md={4} className="mb-1">
                        <ZIPCodeField
                            label="Postal Code"
                            id={`postal_code-${index}`}
                            value={get(record, POSTAL_CODE_PATH)}
                            onChange={(e) => this.handleChange(e, POSTAL_CODE_PATH)} />
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }
}

AddressEdit.propTypes = propTypes;

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getRef,
    addChange,
    clearChange
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddressEdit);
